import React from 'react';
import SmartiLabBadge from './SmartiLabBadge';

function confidenceVariant(level) {
  if (level === 'high') return 'success';
  if (level === 'guarded' || level === 'watch') return 'warning';
  return 'danger';
}

export default function SmartiLabTrustPanel({ trust, compact = false }) {
  if (!trust) return null;

  return (
    <section className={`lab-trust-panel${compact ? ' compact' : ''}`}>
      <div className="lab-trust-head">
        <div>
          <span className="lab-badge">Trust layer</span>
          <h3>Model trust and data readiness</h3>
        </div>
        <div className="lab-chip-row">
          <SmartiLabBadge variant={confidenceVariant(trust.confidenceLevel)} label={`Confidence: ${trust.confidenceLevel || 'unknown'}`} />
          <SmartiLabBadge variant="neutral" label={`Last run: ${trust.lastRunAt ? new Date(trust.lastRunAt).toLocaleString() : 'not available'}`} />
        </div>
      </div>
      <div className="lab-trust-grid">
        <div className="lab-trust-item"><strong>Linked serials</strong><span>{trust.linkedSerialCount ?? 0}</span></div>
        <div className="lab-trust-item"><strong>Ambiguous links</strong><span>{trust.ambiguousLinkCount ?? 0}</span></div>
        <div className="lab-trust-item"><strong>Weak-label warnings</strong><span>{trust.weakLabelWarnings ?? 0}</span></div>
        <div className="lab-trust-item"><strong>Metric warnings</strong><span>{trust.suspiciousMetricWarnings ?? 0}</span></div>
        <div className="lab-trust-item"><strong>Data blockers</strong><span>{trust.dataQualityBlockers ?? 0}</span></div>
        <div className="lab-trust-item"><strong>Human feedback</strong><span>{trust.feedbackCount ?? 0}</span></div>
      </div>
    </section>
  );
}
